// extracted by mini-css-extract-plugin
export default {"filter-category":"PageNavScroll_filter-category__39759","filter-button":"PageNavScroll_filter-button__jZ0xh","category-button":"PageNavScroll_category-button__ogZUo"};